module.exports = __webpack_public_path__ + "d0eaaeb5f298970749adcaffaf4d0b1c.MP3";